document.addEventListener('DOMContentLoaded', () => {
    // Busca todos os botões na página (caso o usuário tenha colocado mais de um por engano, não quebra)
    const buttons = document.querySelectorAll('.wpmundi-scroll-to-top');

    if (!buttons.length) return;

    buttons.forEach(button => {
        // Pega o valor que o usuário definiu no painel (ex: 300px), se não achar, usa 300 como padrão
        const showAfter = parseInt(button.getAttribute('data-show-after'), 10) || 300;

        // Função que verifica a rolagem
        const toggleVisibility = () => {
            if (window.scrollY > showAfter) {
                button.classList.add('is-visible');
            } else {
                button.classList.remove('is-visible');
            }
        };

        // Verifica imediatamente ao carregar a página (caso o usuário atualize a página já lá no meio)
        toggleVisibility();

        // Monitora o Scroll para exibir/ocultar (Aplica a função acima)
        window.addEventListener('scroll', () => {
            // Usa requestAnimationFrame para não pesar o navegador durante a rolagem
            window.requestAnimationFrame(toggleVisibility);
        });

        // Executa a rolagem suave ao clicar
        button.addEventListener('click', (e) => {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth' // Rola para o topo suavemente (não pula de vez)
            });
        });
    });
});